import { Button } from '@folio/stripes/components';
import React from 'react';
import { t } from '../../services';
var Cancel = function (_a) {
    var onCancel = _a.onCancel;
    return (React.createElement(Button
    // @ts-ignore
    , { 
        // @ts-ignore
        buttonStyle: "default mega", onClick: onCancel }, t('button.cancel')));
};
var Save = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, onSave = _a.onSave;
    return (React.createElement(Button
    // @ts-ignore
    , { 
        // @ts-ignore
        buttonStyle: "primary mega", disabled: disabled, onClick: onSave }, t('button.save')));
};
export var Buttons = {
    Save: Save,
    Cancel: Cancel
};
